// Once a draft is clearly taller than the six-line editor, measuring its full
// scrollHeight on every keystroke only forces layout of off-screen text.
export const LONG_COMPOSER_TEXT = 4_096;
export const resizeComposer = (editor: HTMLTextAreaElement | null, value = editor?.value ?? ""): void => {
  if (!editor) return;
  if (value.length > LONG_COMPOSER_TEXT || value.split("\n", 7).length > 6) {
    if (editor.style.height !== "calc(6lh + 6px)") editor.style.height = "calc(6lh + 6px)";
    return;
  }
  const scrollTop = editor.scrollTop;
  editor.style.height = "auto";
  editor.style.height = `${editor.scrollHeight}px`;
  editor.scrollTop = scrollTop;
};
